import styled from 'styled-components';

export const StyledMailchimpSubscribeForm = styled.div`
  max-width: 100%;

  .form-subscribe-button {
    gap: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 9rem;

    img {
      width: 24px;
      padding-bottom: 6px;
    }
  }

  .form-subscribe-success {
    color: green;
  }

  .form-subscribe-error {
    color: red;
  }

  .form-subscribe-container {
    background: rgba(18, 31, 170, 1);
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 2px solid rgba(30, 44, 233, 1);
    padding: 0.5rem;
  }

  .form-subscribe-input {
    max-width: calc(100% - 9rem - 1.5rem);
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    font-size: 2rem;
    font-weight: 700;
    font-family: "BebasNeue"; 
    background: transparent;
    resize: none;
    border: none;
    outline: none;
    caret-color: rgba(59, 104, 251, 1);
    color: rgba(59, 104, 251, 1);
  }

  .form-subscribe-input::placeholder {
    color: rgba(30, 44, 233, 1);
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    .form-subscribe-button-holder {
      width: 100%;
    }

    .form-subscribe-input {
      max-width: 100%;
      width: 100%;
    }

    .form-subscribe-container {
      row-gap: 0.5rem;
      flex-direction: column;
      align-items: start;
    }
    .form-subscribe-button {
      width: 100%;
    }
  }
`;


